export const AppSettings = {

            "LP" : {
                           "WEB_NAME":"Logistics Pharma",
                           "WEB_URL" : "https://logisticspharma.vn",     
                           "FAVICON" : "",
                           "APPLOGO"       :  "assets/images/logo/lp_logo.png",
                           "HOMEPAGE_LOGO" : "assets/images/logo/lp_logo.png",
                           "LOGIN_LOGO"    : "assets/images/logo/lp_logo.png",      
                           "PAGE_BACKGROUND": "assets/images/com/lp_login_bg.png",     
                           "HOMEPAGE_TITLE":"Logistic Pharma"        ,
                           "IS_FIREBASE_ENABLED": false,
                           "SHOW_START_WIZARD":true,
                           "SUBSCRIBE":false,
                           "TOAST": {
                              "duration": 1000,
                              "position": "buttom"
                           },
                           "FIREBASE_CONFIG":{
                              "apiKey":"AIzaSyCJgAyuWNAESAGnLEN1hWQ8mEbbPYkJgmo",
                              "authDomain":"ionic3-yellow.firebaseapp.com",
                              "databaseURL":"https://ionic3-yellow.firebaseio.com",
                              "projectId":"ionic3-yellow",
                              "storageBucket":"ionic3-yellow.appspot.com",
                              "messagingSenderId":"450167842906"
                           },
                           "MAP_KEY":{
                              "apiKey":"AIzaSyCB7jsMv0hjwkVRan7vZZ9hDlI-dQNZRV8"
                           },
                           "CB_SERVER_CONFIG":{
                              "apiKey":"AIzaSyCJgAyuWNAESAGnLEN1hWQ8mEbbPYkJgmo",
                              "APITestDomain":"http://localhost:5000/",      
                              "APILiveDomain":"https://logisticspharma.vn:5000/",      
                              "projectId":"CIIBOS-Mobile Application",               
                              "messagingSenderId":"586483972134"
                           },
                        },

            "ZOO" : {
                           "WEB_NAME":"Saigon Zoo",
                           "WEB_URL" : "https://saigonzoo.net/",
                           "FAVICON" : "",
                           "APPLOGO"    : "assets/images/logo/zoo_logo.png",
                           "HOMEPAGE_LOGO" : "assets/images/logo/zoo_logo.png",
                           "LOGIN_LOGO"    : "assets/images/logo/zoo_logo.png",  
                           "PAGE_BACKGROUND": "assets/images/com/zoo_login_bg.png",     
                           "HOMEPAGE_TITLE":"Saigon Zoo Mobile Application"        ,
                           "IS_FIREBASE_ENABLED": false,
                           "SHOW_START_WIZARD":true,
                           "SUBSCRIBE":false,
                           "TOAST": {
                              "duration": 1000,
                              "position": "buttom"
                           },
                           "FIREBASE_CONFIG":{
                              "apiKey":"AIzaSyCJgAyuWNAESAGnLEN1hWQ8mEbbPYkJgmo",
                              "authDomain":"ionic3-yellow.firebaseapp.com",
                              "databaseURL":"https://ionic3-yellow.firebaseio.com",
                              "projectId":"ionic3-yellow",
                              "storageBucket":"ionic3-yellow.appspot.com",
                              "messagingSenderId":"450167842906"
                           },
                           "MAP_KEY":{
                              "apiKey":"AIzaSyCB7jsMv0hjwkVRan7vZZ9hDlI-dQNZRV8"
                           },
                           "CB_SERVER_CONFIG":{
                              "apiKey":"AIzaSyCJgAyuWNAESAGnLEN1hWQ8mEbbPYkJgmo",
                              "APITestDomain":"http://localhost:5000/",      
                              "APILiveDomain":"https://logisticspharma.vn:5000/",      
                              "projectId":"CIIBOS-Mobile Application",               
                              "messagingSenderId":"586483972134"
                           },
                        },         
                        
            "GENERALPOS" : {
                           "WEB_NAME":"Anh Chị Em",
                           "WEB_URL" : "http://anhchiem.vn",
                           "FAVICON" : "",
                           "APPLOGO"    : "assets/images/logo/ace_logo.png",
                           "HOMEPAGE_LOGO" : "assets/images/logo/ace_logo.png",
                           "LOGIN_LOGO"    : "assets/images/logo/ace_logo.png",       
                           "HOMEPAGE_TITLE":"AnhChiEm Mobile Application"        ,
                           "PAGE_BACKGROUND": "assets/images/com/ace_login_bg.jpg",     
                           "IS_FIREBASE_ENABLED": false,
                           "SHOW_START_WIZARD":true,
                           "SUBSCRIBE":false,
                           "TOAST": {
                              "duration": 1000,
                              "position": "buttom"
                           },
                           "FIREBASE_CONFIG":{
                              "apiKey":"AIzaSyCJgAyuWNAESAGnLEN1hWQ8mEbbPYkJgmo",
                              "authDomain":"ionic3-yellow.firebaseapp.com",
                              "databaseURL":"https://ionic3-yellow.firebaseio.com",
                              "projectId":"ionic3-yellow",
                              "storageBucket":"ionic3-yellow.appspot.com",
                              "messagingSenderId":"450167842906"
                           },
                           "MAP_KEY":{
                              "apiKey":"AIzaSyCB7jsMv0hjwkVRan7vZZ9hDlI-dQNZRV8"
                           },
                           "CB_SERVER_CONFIG":{
                              "apiKey":"AIzaSyCJgAyuWNAESAGnLEN1hWQ8mEbbPYkJgmo",
                              "APITestDomain":"http://localhost:5000/",      
                              "APILiveDomain":"https://logisticspharma.vn:5000/",      
                              "projectId":"CIIBOS-Mobile Application",               
                              "messagingSenderId":"586483972134"
                           },
                        },      
         };


// WEBPACK FOOTER //
// ./src/services/app-settings.ts